import { BaseClient } from '../client';
import { veiculosMarcas } from '../offer/offer.mocks';
import { TVeiculoMarca } from '../offer/offer.types';

export const getVehicleBrands = async (idVehicleType: number | string) => {
	if (process.env.NODE_ENV === 'development') {
		const response: TVeiculoMarca[] = [];

		veiculosMarcas.forEach((marca) => {
			if (marca.veiculoTipo?.id === idVehicleType) response.push(marca);
		});

		return response;
	}

	try {
		const response = await BaseClient.get<TVeiculoMarca[]>(`/VeiculoMarcas/GetVeiculoMarcasPorIdTipo/${idVehicleType}`).then((response) => response.data);

		return response;
	} catch (error) {
		throw error;
	}
};
